import { NAV, type View } from './Sidebar';
import './BottomNav.css';

/**
 * Bottom tab bar, shown only on narrow screens.
 *
 * It exists because the collapsed sidebar rail reduces each destination to a
 * bare glyph whose only label is a `title` tooltip — and tooltips never fire on
 * touch. Insights in particular was reachable but unidentifiable. Every tab here
 * carries its label.
 */
export function BottomNav({
  view,
  onNavigate,
}: {
  view: View;
  onNavigate: (v: View) => void;
}) {
  return (
    <nav className="bottom-nav" aria-label="Main">
      {NAV.map((item) => (
        <button
          key={item.id}
          className={`bn-item${view === item.id ? ' on' : ''}`}
          onClick={() => onNavigate(item.id)}
          aria-current={view === item.id ? 'page' : undefined}
        >
          <span className="bn-icon">{item.icon}</span>
          <span className="bn-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
